import { MixerHorizontalIcon } from '@radix-ui/react-icons';
import {
  Button,
  Card,
  ChevronDownIcon,
  Flex,
  Popover,
  Text,
} from '@radix-ui/themes';
import { ErrorBoundary } from 'components/common/error-boundary';
import { CommonSwitchInput } from 'components/common/form/switch';
import usePitchPerformanceStore from 'components/sections/admin-portal/machines/dialogs/pitch-performance/store/use-pitch-performance-store';
import { RADIX } from 'lib_ts/enums/radix-ui';

// ! deprecate if we never need multiple controls for PP report
export const PitchPerfDisplayOptions = () => {
  const showThresholds = usePitchPerformanceStore((s) => s.showThresholds);

  return (
    <ErrorBoundary identifier="PitchPerfDisplayOptions">
      <Popover.Root>
        <Popover.Trigger>
          <Button
            className="btn-block"
            variant={RADIX.BUTTON.VARIANT.SECONDARY}
            color={RADIX.COLOR.NEUTRAL}
          >
            <MixerHorizontalIcon />
            <Text truncate>Display Options</Text>
            <ChevronDownIcon />
          </Button>
        </Popover.Trigger>
        <Popover.Content>
          <Card>
            <Flex direction="column" gap="2">
              <CommonSwitchInput
                id="show-thresholds"
                label="Thresholds"
                size="1"
                checked={showThresholds}
                onCheckedChange={(v) =>
                  usePitchPerformanceStore.setState({ showThresholds: v })
                }
                justify
                reverse
              />
            </Flex>
          </Card>
        </Popover.Content>
      </Popover.Root>
    </ErrorBoundary>
  );
};
